var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-loading",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-8 0)",
    d: "M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "-8 0; 2 0; 2 0;",
    dur: "0.8s",
    repeatCount: "indefinite",
    begin: 0,
    keyTimes: "0;.25;1",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8",
    calcMode: "spline"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 0)",
    d: "M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "2 0; 12 0; 12 0;",
    dur: "0.8s",
    repeatCount: "indefinite",
    begin: 0,
    keyTimes: "0;.35;1",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8",
    calcMode: "spline"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(12 0)",
    d: "M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "12 0; 22 0; 22 0;",
    dur: "0.8s",
    repeatCount: "indefinite",
    begin: 0,
    keyTimes: "0;.45;1",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8",
    calcMode: "spline"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(24 0)",
    d: "M4 12 A4 4 0 0 0 4 20 A4 4 0 0 0 4 12"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "22 0; 32 0; 32 0;",
    dur: "0.8s",
    repeatCount: "indefinite",
    begin: 0,
    keyTimes: "0;.55;1",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8",
    calcMode: "spline"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.13001fa5837f4f093406ff677cb61913.svg";
export { ForwardRef as ReactComponent };